import routes, { AUTHORIZED_ROUTES_WL } from '../constants/routing.constants';
import { stores } from '../../stores';
import history from '../../customHistory';
import { captureError } from '../utils/error.util';

class WizardService {
  isInited = false;

  async init() {
    if (!this.isInited) {
      const { pathname } = window.location;
      const { startedFromWizard } = stores.ProfileStore.metaData;

      try {
        // if (
        //   startedFromWizard &&
        //   pathname !== routes.wizard.path &&
        //   !AUTHORIZED_ROUTES_WL.includes(pathname) &&
        //   !stores.AccountsStore.hasInvestorAccount
        // ) {
        //   history.push(routes.wizard.path);
        // }

        if (
          pathname === routes.wizard.path &&
          !stores.AccountsStore.hasInvestorAccount
        ) {
          stores.ProfileStore.updatePersonalInfo({ startedFromWizard: true });
        }
      } catch (e) {
        captureError(e);
      }

      this.isInited = true;
    }
  }
}

export const wizardService = new WizardService();
